import React from 'react';

export const SecondaryButton = ({label, handleClick}) => {
  return (
    <button className="btn btn-block btn-pill btn-secondary btn-fill-h" onClick={handleClick}>
      <span>{label}</span>
    </button>
  );
};